import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus, Filter } from 'lucide-react';

const mockBills = [
  { id: 1, vendor: 'ABC Plumbing', amount: 450, dueDate: '2025-11-05', status: 'pending' },
  { id: 2, vendor: 'XYZ Electric', amount: 1200, dueDate: '2025-11-10', status: 'pending' },
  { id: 3, vendor: 'Lawn Care Pro', amount: 300, dueDate: '2025-10-28', status: 'overdue' },
  { id: 4, vendor: 'Insurance Co', amount: 2500, dueDate: '2025-10-25', status: 'paid' },
];

export default function BillsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Bills</h1>
          <p className="mt-2 text-gray-600">Manage vendor bills and payments</p>
        </div>
        <div className="flex gap-3">
          <Button variant="outline">
            <Filter className="mr-2 h-4 w-4" />
            Filter
          </Button>
          <Button>
            <Plus className="mr-2 h-4 w-4" />
            New Bill
          </Button>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Recent Bills</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {mockBills.map((bill) => (
              <div
                key={bill.id}
                className="flex items-center justify-between rounded-lg border p-4 transition-colors hover:bg-gray-50"
              >
                <div className="flex items-center gap-4">
                  <Badge
                    variant={
                      bill.status === 'paid'
                        ? 'success'
                        : bill.status === 'overdue'
                          ? 'destructive'
                          : 'warning'
                    }
                  >
                    {bill.status}
                  </Badge>
                  <div>
                    <p className="font-medium text-gray-900">{bill.vendor}</p>
                    <p className="text-sm text-gray-500">Due: {bill.dueDate}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-lg font-semibold text-gray-900">${bill.amount}</p>
                  {bill.status === 'pending' && (
                    <Button size="sm" variant="outline" className="mt-2">
                      Pay Now
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
